'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from 'react';
import { cn } from '../../utils/cn';
import { ProgressContext } from './Context';
import { progressTheme } from './theme';
const CircleProgress = forwardRef(({ progress = 0, children, className, ...props }, ref) => {
    const [progressBar, setProgressBar] = useState(0);
    const { circle } = progressTheme;
    useEffect(() => {
        const timer = setTimeout(() => setProgressBar(progress), 200);
        return () => clearTimeout(timer);
    }, [progress]);
    return (_jsx("div", { ref: ref, ...props, className: cn(circle.root, className), children: _jsx(ProgressContext.Provider, { value: { progressBar: progressBar }, children: children }) }));
});
CircleProgress.displayName = 'CircleProgress';
export { CircleProgress };
